import { render } from "./PropertyDetailView.vue?vue&type=template&id=dba070a2"
import script from "./PropertyDetailView.vue?vue&type=script&lang=js"
export * from "./PropertyDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__